import gql from 'graphql-tag';

export const LEADGEN_FORM_TEMPLATES_QUERY = gql`
  query LeadgenFormTemplatesQuery($articleGroupId: ID!) {
    leadgenFormTemplates(articleGroupId: $articleGroupId) {
      id
      name {
        text
      }
      blockDisplayForNonTargetedViewer
      isOptimizedForQuality
      locale
      contextCard {
        style
        title {
          text
        }
        contents {
          order
          value {
            text
          }
        }
      }
      privacyPolicy {
        url
        linkText {
          text
        }
      }
      thankYouPage {
        buttonType
        title {
          text
        }
        body {
          text
        }
        buttonText {
          text
        }
      }
      customDisclaimer {
        title {
          text
        }
        bodyText {
          text
        }
        urlEntities {
          url
          length
          offset
        }
        checkboxes {
          isRequired
          isCheckedByDefault
          order
          text {
            text
          }
        }
      }
      questionPage {
        questionPageCustomHeadline {
          text
        }
        questions {
          order
          type
        }
        customQuestions {
          order
          label {
            text
          }
          options {
            order
            value {
              text
            }
          }
        }
      }
    }
  }
`;
